import {
  getCommunityGroupsData,
  getCommunityNames,
  getCommunityTableColumns,
  getHouseholdNumbersInfoTableColumns,
} from '../helper';
import { Card, Select, Space, Table, Typography } from 'antd';
import React, { useMemo, useState } from 'react';

import CommunityGroups from '@/types/database/communityGroups';
import useService from '@/lib/hooks/useService';

import AddAndEditCommunity from '../AddAndEditCommunityModal';
import styles from './index.module.scss';

const { Title } = Typography;

const InformationManagement = () => {
  const [communityGroups, updateCommunityGroups] = useService<CommunityGroups>({
    collectionName: 'communityGroups',
  });

  const [selectedCommunityName, setSelectedCommunityName] = useState<
    string | undefined
  >('');

  const communityTableColumns = useMemo(() => {
    const columns = getCommunityTableColumns(updateCommunityGroups);
    return columns;
  }, [updateCommunityGroups]);

  const communityGroupsData = getCommunityGroupsData(
    communityGroups,
    selectedCommunityName
  );

  const communityNameOptions = useMemo(() => {
    const options = getCommunityNames(communityGroups);
    return options;
  }, [communityGroups]);

  const householdNumbersInfoTableColumns = useMemo(() => {
    const householdNumbersInfoTableColumns =
      getHouseholdNumbersInfoTableColumns();
    return householdNumbersInfoTableColumns;
  }, []);

  return (
    <Space direction="vertical" className={styles.widthFull} size={50}>
      <Space direction="vertical" className={styles.widthFull}>
        <AddAndEditCommunity
          formType="add"
          updateCommunityGroups={updateCommunityGroups}
        />
        <Card>
          <Title level={5}>社區群組</Title>
          <Table
            rowKey="_id"
            bordered
            scroll={{ x: 'max-content' }}
            columns={communityTableColumns}
            dataSource={communityGroups}
          />
        </Card>
      </Space>
      <Space direction="vertical" className={styles.widthFull}>
        <div>
          <span>社區：</span>
          <Select
            allowClear
            placeholder="請選擇社區名稱"
            className={styles.input}
            options={communityNameOptions}
            onChange={(option) => setSelectedCommunityName(option)}
          />
        </div>
        <Card>
          <Title level={5}>社區住戶資料</Title>
          <Table
            rowKey="_id"
            bordered
            scroll={{ x: 'max-content' }}
            columns={householdNumbersInfoTableColumns}
            dataSource={communityGroupsData}
          />
        </Card>
      </Space>
    </Space>
  );
};

export default InformationManagement;
